export default __webpack_public_path__ + "static/media/_IMG1183.72a2ba95.jpg";